import { defaultFilters } from '@helpers/filters';

import { Filters } from './SearchTypes';

function filtersDifferFromDefaultExcludingPeople(filters: Filters): boolean {
  const def = defaultFilters();
  const keys = Object.keys(def) as (keyof Filters)[];
  for (const k of keys) {
    if (k === 'people') {
      continue;
    }
    if (JSON.stringify(filters[k]) !== JSON.stringify(def[k])) {
      return true;
    }
  }
  return false;
}

export type PeopleSearchExecuteType =
  | 'people_filter_only'
  | 'people_filter_combined'
  | 'people_keyword_search';

/**
 * #14 — when a search uses people (panel, keyword, or identity from face click).
 */
export function resolvePeopleSearchExecuteSearchType(args: {
  filters: Filters;
  searchQuery: string;
  identityIdFromFace?: string | null;
}): PeopleSearchExecuteType | null {
  const { filters, searchQuery, identityIdFromFace } = args;
  const hasPanel = (filters.people?.length ?? 0) > 0;
  const q = (searchQuery || '').trim();
  const hasPeopleStrict = q.includes('people.strict:');
  const hasOtherAdv = filtersDifferFromDefaultExcludingPeople(filters);
  const qWithoutPeople = q
    .replace(/people\.strict:\("[^"]*"\)/g, '')
    .replace(/\s+(AND|OR)\s+/gi, ' ')
    .trim()
    .replace(/^\(+|\)+$/g, '')
    .trim();
  const hasOtherQueryText = qWithoutPeople.length > 0;

  const peopleInvolved = hasPanel || hasPeopleStrict || Boolean(identityIdFromFace);
  if (!peopleInvolved) {
    return null;
  }

  if (hasPeopleStrict && !hasPanel && !hasOtherAdv && !hasOtherQueryText) {
    return 'people_keyword_search';
  }

  if (!hasPeopleStrict && hasPanel && !hasOtherAdv && !hasOtherQueryText && !identityIdFromFace) {
    return 'people_filter_only';
  }

  if (!hasPanel && !hasPeopleStrict && identityIdFromFace && !hasOtherAdv && !hasOtherQueryText) {
    return 'people_keyword_search';
  }

  return 'people_filter_combined';
}
